export const FETCH_DATA = "FETCH_DATA";
export const ACTIVATE_SUBSCRIPTION = "ACTIVATE_SUBSCRIPTION";